
export default {
  locale: 'zh-CN',
  language: '简体中文',
  menu: {
    i18n: '多语言'
  },
  page: {
    supReg: {
      title: '注册',
      stepName:['注册流程','入网供应商须知','恪守商业道德协议','申请用户名','供应商基本信息','联系信息','产品信息','财务信息','历史合作业绩','资质文件'],
      contentTitle:['1、请仔细阅读入网供应商须知','2、阅读并同意《恪守商业道德协议》','3、申请用户名','4、填写详细信息，上传资质文件（*为必填项）','5、确认信息，提交，进入审核，审批流程'],
      contentP:['','勾选“已阅读并同意《恪守商业道德协议》”','按需求申请用户名，填写联系人详细信息，选择推荐单位','认真填写供应商详细信息并上传相关的资质文件，以备查询','确认填写信息准确无误后，点击“提交”按钮'],
    },
    supNotice: {
      contentTitle: '入网供应商须知',
      contentP: ['1. 中交集团供应链管理信息系统是供应商加入中国交通建设集团有限公司（以下简称“中交集团”）供应商网络的唯一合法网站。中交集团按照“互利共赢、诚信合作”的原则，与供应商建立积极的合作关系。',
      '2. 中国交通建设集团有限公司对申请入网的供应商不收取任何费用，也不以年审、会员制、业绩考核等名义向供应商收取费用。供应商填写入网信息必须真实、准确并及时更新。',
      '3.如遇系统升级，平台运营方有权延长招标结束时间、售标结束时间。'],
    },
    moralAgree: {
      contentTitle: '各供应商：为了进一步规范商业行为，请仔细阅读《恪守商业道德协议》。',
      contentH: ['恪守商业道德协议','甲方：中国交通建设集团有限公司物资采购管理中心','乙方：','第一条 甲乙双方共同责任','第二条 中国交通建设集团有限公司',
      '第三条','第四条 违约责任','第五条 本协议经双方签署后生效','第六条 甲乙双方及其人员在经济合同履行完毕后，发生或发现违反本协议规定的行为，仍按本协议规定处理。'],
      contentP:['为规范甲乙双方的商业行为，维护公平竞争，建立健全恪守商业道德的长效机制，深入推进反腐倡廉工作，根据国家有关法律法规和中国交通建设集团有限公司（以下简称“中国交建”）有关规定，经双方协商，签订恪守商业道德协议。',
      '（一）严格遵守国家有关法律法规以及廉洁从业的有关规定。',
      '（二）严格遵守商业道德和市场规则，共同营造公平公正的商务交易环境',
      '（三）加强有关人员的管理和恪守商业道德教育，自觉抵制不廉洁行为。在商务活动中发现对方存在违规违纪违法行为，应及时向对方监察部门 或司法机关举报',
      '（一）不得索要或接受乙方及其相关单位和人员提供的回扣、礼金、有价证券、支付凭证、贵重物品等。',
      '（二）不得在乙方及其相关单位报销任何应由甲方或个人支付的费用。',
      '（三）不得违反规定在乙方及其相关单位投资入股，不得向乙方单位及人员借款或委托买卖股票、债券等。',
      '（四）不得要求、暗示和接受乙方及其相关单位和个人为其购买或装修住房、婚丧嫁娶、配偶和子女的上学或工作安排以及出国（境）、旅游等提供方便。',
      '（五）不得参加乙方及其相关单位安排的可能影响公正执行公务的宴请及健身、娱乐等活动。',
      '（六）不得接受乙方及其相关单位购置或提供的通讯工具、交通工具和高档办公用品。',
      '（七）不得利用职权通过乙方及其相关单位为其配偶、子女及他人谋取不正当利益。',
      '（八）不得违反规定在乙方或乙方相关单位兼职和领取兼职工资及报酬；不得利用甲方的商业秘密、业务渠道等谋取个人私利，或将其提供泄漏给乙方及其它企业和个人。',
      '（九）不得利用职权和工作之便向乙方提出上述各项规定禁止事项或要求之外的与工作业务无关的事项或要求。',
      '（一）不得向甲方及其人员提供回扣、礼金、有价证券、支付凭证、贵重物品等。',
      '（二）不得为甲方及其人员报销应由甲方或个人支付的费用。',
      '（三）不得为甲方人员投资入股、个人借款或买卖股票、债券等提供方便。',
      '（四）不得为甲方人员购买或装修住房、婚丧嫁娶、配偶子女上学或工作安排以及出国（境）、旅游等提供方便。',
      '（五）不得为甲方人员安排有可能影响公正执行公务的宴请、健身、娱乐等活动。',
      '（六）不得为甲方及其人员购置或提供通讯工具、交通工具和高档办公用品',
      '（七）不得为甲方人员的配偶、子女及其他亲属谋取不正当利益提供方便。',
      '（八）不得违反规定安排甲方人员在乙方或乙方相关企业兼职和领取兼职工资及报酬；不得利用非法手段向甲方人员打探有关涉及甲方的商业秘密、业务渠道等。',
      '（九）甲方对涉嫌不廉洁的商业行为进行调查时，乙方有配合甲方提供证据、作证的义务。',
      '（十）确保提供的资质文件、财务报表、历史合作业绩等资料均为真实有效，不存在弄虚作假、欺骗、伪造、变造等情况。',
      '（十一）遵守质量诚信，确保合同供应产品的质量、数量符合要求，手续合法完备。主动支持和配合中国交建及其所属单位组织的履约验收工作。',
      '（十二）遵守价格诚信。确保合同供应的产品和服务成交价格不高于该产品和服务的同期市场价格；保证相同条件下为中国交建及其所属单位供应的产品和服务价格基本相同。',
      '（十三）自觉遵守和严格履行合同，不擅自变更或终止合同，确保所供应的产品符合合同要求。',
      '（十四）遵守服务诚信。不断增强服务意识，改进服务态度，提高服务质量，为中国交建及其所属单位提供及时、便捷、周到的技术支持与服务，及时妥善解决售前、售中、售后过程中出现的各种问题。',
      '（十五）遵守保密协议。未经中国交建及其所属单位同意，不得向第三方透露在合作期间获得和知晓的商业机密。',
      '（十六）未经甲方书面同意，乙方不得向任何新闻媒体、第三人述及有关中国交建恪守商业道德方面的评价、信息。',
      '（一）甲方及其人员有违反本协议第一条、第二条规定的，按照管理权限，依据有关法律法规和规定给予有关人员纪律处分或组织处理；涉嫌犯罪的，移交司法机关追究刑事责任。',
      '（二）乙方及其人员有违反本协议第一条、第三条规定的，对属于中国交建管理的单位，按照管理权限，依据国家法律法规和有关规定给予纪律处分或组织处理；涉嫌犯罪的，移交司法机关追究刑事责任。 对不属于中国交建管理的单位，根据具体情节和造成的后果，甲方除有权要求乙方赔偿由此造成的甲方损失外，还将分别在中国交建及其所属单位的注册供应商范围内给予通报或解除合作关系的处理；涉嫌犯罪的，建议司法机关追究刑事责任。',
      '甲乙双方通过招投标或其他方式签订交易合同的，本协议作为双方所有交易合同的附件，与合同具有同等法律效力；如双方未签订交易合同， 本协议独立有效。',
      ],
      errMsg: ['请先勾选已阅读并同意恪守商业道德协议'],
      contentCheckbox:['已阅读并同意恪守商业道德协议'],
    },
    applyUsername: {
      contentTitle: {loginInfo:'登录账号和密码',contacts:'联系人和联系方式',reCompany:'推荐单位'},
      contentTitles: {contactsWay:'固定电话、手机和E-mail为重要联系方式，请务必认真填写',reCompanyMsg:'请慎重选择推荐单位。推荐单位为供应商注册的初审单位，选择后将不可更改。'},
      contentLabel: {supName:'供应商名称:',id:'登录账号:',authCode:'验证码:',pwd:'密码:',repwd:'重复输入密码:',
        contacts:'联系人:',contactsTel:'联系人固定电话:',contactsFax:'联系人传真:',contactsMobile:'联系人手机:',contactsInfo:"联系人和联系方式",
        contactsEmail:'联系人邮箱:',provinces:'省市地区:',reCompany:'推荐单位:',mobile: '手机号:',ID:'联系人身份证号/境外社保号:'},
      inputPlc: {supNameMSg:'请输入供应商名称',idMsg:'请输入登录账号，支持字母或字母数字结合',authCodeMsg:'请输入短信验证码',pwdMsg:'8-16位大小写字母,特殊字符和数字的结合',
        repwdMsg:'请再次输入密码',contactsMsg:'请输入联系人姓名',contactsTelMsg:'请输入区号和固定电话号码，例：“010-******”',contactsFaxMsg:'请输入区号和传真号码，例:“010-********”',contactsMobileMsg:'请输入正确的手机号码',
        contactsEmailMsg:'请输入E-mail',IDMsg:'请输入联系人身份证号/境外社保号',provincesMsg:'请选择省市地区',reCompanyMsg:'请选择推荐单位'},
      inputRules: {pwdMsg1:'长度在8到16个字符',pwdMsg2:'密码中必须包含大小字母、数字、特称字符',repwdMsg:'两次输入的密码不一致',contactsMsg:'姓名格式不正确',
        contactsTelMsg:'联系人固定电话格式不正确(格式：区号+号码，如010-1234567)',contactsFaxMsg:'联系人传真格式不正确(格式：区号+号码，如010-1234567)',contactsMobileMsg:'手机号格式不正确',contactsEmailMsg:'邮箱格式不正确',
        provincesMsg:'请选择省市地区',sliderMsg: '请先输入手机号',reCompanyMsg: '推荐单位不能为空',reCompanyMsg1: '推荐单位不存在',
        reCompanyMsg2: '请输入非集团总部单位',supNameMSg:'供应商名称不能为空',supNameMSg1: '该供应商名称已存在',codemsg: '验证码不能为空',mobilemsg: '手机号不能为空',mobilemsg1: '该手机号已存在'},
      btn: {getCode: '获取验证码',msg1: '请按住滑块，拖动到最右侧',msg2: '验证通过',msg3: '加载中',msg4: '验证不通过',msg5:'哎呀出错了，点击',
        msg6:'刷新',msg7:'再来一次',msg8: '网络不给力，请',msg9:'点击刷新',msg10:'我已注册，查看审批进展'},
      dialogMsg: {msg1: '您现在选择的推荐单位是',msg2:',推荐单位负责审核您公司的注册信息。请仔细核对，避免出错！',title:'提示'}
    },
    supInfo: {
      contentTitle: {basicInfo:'基本信息',producer:'生产商（填写）',dealer:'经销商（填写）'},
      contentLabel: {supName:'供应商名称:',abbreviation:'简称:',supType:'供应商类型:',hisName:'历史名称：',isForeign:'是否为外贸供应商:',isInside:'是否为中交内部单位:',isThree:'是否三证合一:',unifyCode:'统一社会信用代码:',GATunifyCode:'港澳台统一代码证:',framework:'组织机构代码:',
        organization:'组织机构代码证件有效期:',dutyParagraph:'税号:',domicile:'住所:',businessAddress:'办公地址:',postcode:'邮编:',registeredCapital:'注册资本(万元):',currency:'币种:',capital:'实收资本(万元):',UniProperty:'单位性质',companyType:'公司类型:',businessScope:'经营范围:',foundingTime:'成立时间:',businessTerm:'营业期限:',
        organizationChart:'组织架构及营销网络:',companyName:'所属集团公司名称:',companyProfile:'公司简介:',capacity:'产能:',processStatus:'工艺技术状况:',manufacturer:'所销售产品的生产商名称:',qualification:'销售代理资格:',userInfo:'登录账号和密码',
      country: '注册国家',business: '营业执照号',organiza: '分支机构及联系方式',unitCategory:'单位类别',abroadSocialSecurity:'境外社保号'},
      inputPlc: {supName:'请输入供应商名称',abbreviation:'请输入简称',unitCategory:'请输入单位类别',hisName:'请输入历史名称',choose:'请选择',yes:'是',no:'否',unifyCode:'请输入统一社会信用代码',GATunifyCode:'请输入港澳台统一代码证',framework:'请输入组织机构代码',chooseDate:'选择日期',dutyParagraph:'请输入税号',domicile:'请输入住所',
        businessAddress:'请输入办公地址',UniProperty:'请选择单位性质',postcode:'请输入邮编',registeredCapital:'请输入注册资本',capital:'请输入实收资本',input:'请输入',country: '请选择国别',
        business: '请输入营业执照号',organiza:'请输入分支机构及联系方式',personal:'个人',company:'单位',abroadSocialSecurity:'请输入境外社保号'},
      inputRules: {supType:'请选择供应商类型',choose:'请选择是或否',chooseDate:'请填写完整日期',chooseCurrency:'请选择币种',conpanyType:'请选择公司类型',businessScope:'请输入经营范围',foundingTime:'请选择成立时间',businessTerm:'请选择营业期限',max:'最大不能超过6位',postcode:'邮编格式不正确',
        organizationChart:'请输入组织架构及营销网络',companyProfile:'请输入公司简介',unitCategoryType:'请选择单位或个人',abroadSocialSecurity:'请输入境外社保号'},
    },
    contactInfo: {
      contentTitle: {contactsInfo:'联系信息'},
      contentLabel: {legalName:'法人代表姓名:',controlAgent:'实控主体',xuhao:'序号',controlType:'实控类型',controlId:'控制主体代码或证件号',legalMobile:'法人代表手机:',saleID:'销售负责人身份证号/境外社保号',legalTel:'法人代表固定电话:',legalID:"法人代表身份证号/境外社保号",legalFax:'法人代表传真:',legalEmail:'法人代表邮箱:',market:'销售负责人:',marketMobile:'销售负责人手机:',marketTel:'销售负责人固定电话:',
      marketFax:'销售负责人传真:',marketEmail:'销售负责人邮箱:',web:'公司网址:',DJG:"董监高",DJGT:'董监高类型',DJGN:'董监高人员姓名',DJGID:'董监高人员证件号'},
      inputPlc: {legalNameMsg:'请输入法人代表姓名',legalMobileMsg:'请输入法人代表手机号码',saleID:'请输入销售负责人身份证号/境外社保号',legalID:'请输入法人代表身份证号/境外社保号',legalTelMsg:'请输入法人代表区号和固定电话号码，例:“010-********”',legalFaxMsg:'请输入法人代表区号和传真号码，例:“010-********”',
      legalEmailMsg:'请输入法人代表电子邮箱地址',marketMsg:'请输入销售负责人姓名',marketMobileMsg:'请输入销售负责人手机号码',marketTelMsg:'请输入销售负责人区号和固定电话号码，例:“010-********”',
      marketFaxMsg:'请输入销售负责人区号和传真号码，例:“010-********”',marketEmailMsg:'请输入销售负责人电子邮箱地址',webMsg:'请输入网址'},
      inputRules: {mobileMsg:'手机号格式不正确',legalTelMsg:'法人代表固定电话格式不正确(格式：区号+号码，如010-1234567)',legalFaxMsg:'法人代表传真格式不正确(格式：区号+号码，如010-1234567)',
      marketTelMsg:'销售负责人固定电话格式不正确(格式：区号+号码，如010-1234567)',marketFaxMsg:'销售负责人传真格式不正确(格式：区号+号码，如010-1234567)',emailMsg:'邮箱格式不正确'},
    },
    productInfo: {
      contentTitle: {productInfo:'产品信息'},
      tableTh: {productCode:'产品编码',productName:'产品名称',productTrademark:'产品商标',remark:'备注',operation:'操作'},
      btn: {add:'添加',newAdd:'新增',batchDel:'批量删除',del:'删除',cancel: '取消',confirm: '确定'},
      dialog: {info: '提示',title: '设备物资选择',inp: '请输入',nextMsg: '请选择至少一条产品信息'},
      delInfo: {batchDelInfo: '请选择至少一条数据进行删除',delInfo: '此操作将永久删除该文件，是否继续',confirmDel: '删除成功',cancelInfo: '已取消删除'}
    },
    financeInfo: {
      contentTitle: {financeInfo:'财务信息'},
      contentLabel: {bankAccount:'银行账号:',depositBank:'开户银行:',bankAccountName:'银行账户名称',bankAddress:'银行地址',beneficiary:'收款人地址',
        swiftCode:'银行国际代码',isWhether:'是否接收信用卡付款'},
      inputPlc: {bankAccountMsg:'请输入银行账号',depositBankMsg:'请输入开户银行',bankAccountNameMsg:'请输入银行账户名称',bankAddressMsg:'请输入银行地址',beneficiaryMsg:'请输入收款人地址',
      swiftCodeMsg:'请输入银行国际代码',isWhetherMsg:'请选择是或否'},
    },
    hisCooperation: {
      contentTitle: {hisCooperation:'历史合作业绩'},
      contentLabel: {cooperationCompany:'合作企业:',cooperationPerformance:'与中交合作业绩:',peerCooperation:'与同行业企业合作业绩:',remark:'备注:'},
      inputPlc: {input:'请输入',cooperationCompanyMsg:'请输入合作企业'},
    },
    qualificationFile: {
      contentTitle: {qualificationFile:'资质文件信息'},
      contentTitles: {hintMsg1:'提示：请上传原件扫描件，图片文件应小于',hintMsg2:'15',hintMsg3:'M,其他文件应小于',hintMsg4:'30M'},
      tableTh: {name:'附件名称',type:'附件类型',file:'文件', enclosureNotation:'附件说明',operation:'操作',input:'请输入',size: '附件大小'},
      tableTd: {businessLicense:'营业执照副本图片',identityCard:'法人代表身份证复印件',frameworkImg:'组织机构代码证图片',taxationImg:'税务登记证图片',taxationImg2:'(含增值税一般纳税人红章页面)',qualityControl:'质量管理体系认证证书',
        specialIndustry:'特殊行业资质证书图片',organizationChart:'组织架构及营销网络相关文件',companyQualification:'公司资质及荣誉文件',productionLicence:'生产许可证图片',distributiontImg:'经销代理资格证明图片',financialStatement:'财务报表(上年度经审计的财务报表)',
        cooperationFile:'合作业绩证明文件',businessLicenses:'经营许可证',environmentalManagement:'环境管理体系认证证书图片',healthySafety:'健康安全管理体系认证证书图片',otherFiles:'其他文件',transportation:'运输许可证(多张需合并上传)',img:'图片',file:'文件'},
      btn: {uploading:'上传',del:'删除'},
      info: {uploadErr1: '上传图片支持格式：.jpg .png .jpeg .gif .webp每个不超过15M',uploadErr2: '上传图片大小不能超过 15M!',
      uploadErr3: '上传文件支持格式：.xls .xlsx .doc .docx .pdf每个不超过30M',uploadErr4: '上传文件大小不能超过 30M!',
      delErr: '请先上传文件',subErr1: '营业执照副本图片不能为空',subErr2: '组织机构代码证图片不能为空',subErr3: '税务登记证图片不能为空',subErr4:'运输许可证文件不能为空',sameFile:'请不要上传重名文件!',
      dialog1: '请确认所填信息的真实有效，您是否确定提交？',dialog2: '您已成功提交注册申请信息，请耐心等待',upload1: '文件上传成功'},
      file:{
        download:"下载",
        clickdownload:"点击下载",
        tip:"（含增值税一般纳税人红章页面）"
      }
    },
    mobileValidate: {
      title1:{name:"用户名",psd:"密码"},
      inputPlc: {mobile: '请输入手机号',name:"请输入用户名",psd:"请输入密码"},
      inputRules: {mobile: '请输入正确的手机号',code: '请输入六位数字验证码'},
      title: {title: '使用账号密码完成身份认证，查询注册审批进展'},
      btn: {code: '发送验证码',sub:'提交认证'},
      msg: {q:'收不到短信验证码？',a:'请检查手机网络并核实手机是否屏蔽系统短信，如均正常请重新获取或稍后再试。',msg1:'当前手机号未注册供应商'}
    },
    foreignSupRegDetail: {
      btn: {perfect1: '完善信息',recall: '撤回申请',perfect2: '修改信息'},
      msg: {msg1:'贵公司注册信息已开始由',msg2:'审批，不允许供应商撤回注册申请',msg3: '贵公司注册信息还未开始审批，确定要撤回注册申请吗？',
      msg4: '撤回申请成功',msg5: '已取消撤回申请'}
    },
    approval: {
      title: {title:'审批记录',title1: '说明',title2: '结论',title3: '意见'},
      msg: {msg1: '审批中',msg2: '暂无数据'}
    }
  }
};
